import React from "react";
import { Navigate, useNavigate } from "react-router-dom";

// Hook
import { useAuth } from "../hooks/useAuth";

// Components
import { BlueButton, YellowButton } from "../components/Buttons";
import Divider from "../components/Divider";
import MainView from "../components/MainView";

// Helpers
import { checkAuth } from "../helpers/authHelper";

// Assets
import bunnyImg from "../assets/core/img/bunny.png";
import listBulletImg from "../assets/core/img/list_bullet.png";
import trophyImg from "../assets/core/img/trophy.png";

export default function Landing() {
  const navigate = useNavigate();

  const { auth } = useAuth();

  const { refresh_token_expired } = checkAuth(auth.token);

  // Check Auth State and Redirect to Games Page if Authenticated
  return !refresh_token_expired ? (
    <Navigate to="/games" replace />
  ) : (
    <MainView>
      <div className="py-5 px-[5vw] 2xl:px-[15vw]">
        <div className="flex flex-col items-center h-full mx-auto w-[80vw] sm:w-48 xl:w-72">
          <div className="w-full mb-4">
            <BlueButton
              onClick={() => {
                navigate("/signin");
              }}
            >
              Sign In
            </BlueButton>
          </div>
          <div className="w-full">
            <YellowButton
              onClick={() => {
                navigate("/signup");
              }}
            >
              Sign Up
            </YellowButton>
          </div>
        </div>
      </div>

      <Divider />

      <div className="pt-8 pb-20 px-[5vw] 2xl:px-[15vw]">
        <div className="mx-auto xl:max-w-5xl">
          <p className="font-retro-rounded text-center text-xl xl:text-3xl">
            RETROrehab are a series of games you can play on your computer.
            Using your computer’s camera, you are able to control the cursor
            with your movements and collect all the points!
            <br />
            <br />
            Compare your scores to people your age or compete against yourself
            to get a new personal best!
          </p>
        </div>
      </div>

      <div className="pt-8 pb-20 px-[5vw] 2xl:px-[15vw]">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mx-auto xl:max-w-5xl">
          <div className="sm:w-[45%]">
            <img
              src={trophyImg}
              alt=""
              className="mx-auto w-[80%] sm:w-[80%]"
            />
          </div>
          <div className="mt-4 sm:mt-0 sm:w-[45%]">
            <div className="font-retro-rounded text-xl leading-relaxed xl:text-3xl text-center">
              <span className="leading-loose">Play RETROrehab games to:</span>
              <br />
              <ul className="list-disc list-inside leading-relaxed">
                <li>improve balance</li>
                <li>work on endurance</li>
                <li>reduce falls risk</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="pt-8 pb-20 px-[5vw] 2xl:px-[15vw]">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mx-auto xl:max-w-5xl">
          <div className="sm:w-[45%] pb-5 sm:pb-10">
            <p className="font-retro-rounded font-bold text-xl leading-relaxed xl:text-3xl">
              Play in 3 easy steps
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mx-auto xl:max-w-5xl">
          <div className="sm:w-[65%]">
            <ul className="font-retro-rounded text-base sm:text-xl leading-relaxed xl:text-3xl">
              <li className="flex items-center pb-5 sm:pb-8 last:pb-0">
                <img
                  src={listBulletImg}
                  alt=""
                  className="w-10 mr-4 sm:mr-10"
                />
                <span>Create an account</span>
              </li>
              <li className="flex items-center pb-5 sm:pb-8 last:pb-0">
                <img
                  src={listBulletImg}
                  alt=""
                  className="w-10 mr-4 sm:mr-10"
                />
                <span>Click on the game you want to play</span>
              </li>
              <li className="flex items-center pb-5 sm:pb-8 last:pb-0">
                <img
                  src={listBulletImg}
                  alt=""
                  className="w-10 mr-4 sm:mr-10"
                />
                <span>Accept permission on your camera</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="pb-20 px-[5vw] 2xl:px-[15vw]">
        <div className="flex flex-col sm:flex-row pb-36 sm:pb-20 mx-auto xl:max-w-5xl relative">
          <div className="mx-auto w-[80vw] sm:w-48 xl:w-72">
            <YellowButton
              onClick={() => {
                navigate("/signup");
              }}
            >
              Sign Up
            </YellowButton>
          </div>

          <div className="absolute right-[5vw] bottom-0 h-28 w-28">
            <img src={bunnyImg} alt="" />
          </div>
        </div>
      </div>
    </MainView>
  );
}
